<template>
  <div>
    <p class="part-title">实验简介
    </p>
    <p class="tips">（实验的必要性及实用性，教学设计的合理性，实验系统的先进性）</p>
    <div
      class="part-content"
      v-if="!formInfo.introduce"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.introduce"
      v-html="formInfo.introduce"
    ></div>
    <p class="part-title">实验教学目标
    </p>
    <p class="tips">（实验后应达到的知识、能力水平）</p>
    <div
      class="part-content"
      v-if="!formInfo.tech_goal"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.tech_goal"
      v-html="formInfo.tech_goal"
    ></div>
    <p class="part-title">实验课时
    </p>
    <div class="part-content">
      <span class="content-title">实验所属课程课时：</span>
      <div>
        <span class="content_underline">{{formInfo.time_lesson?formInfo.time_lesson:'暂无内容'}}</span>学时
      </div>
      <span class="content-title">该实验所占课时：</span>
      <div>
        <span class="content_underline">{{formInfo.time_experiment?formInfo.time_experiment:'暂无内容'}}</span>学时
      </div>
    </div>
    <p class="part-title">实验原理
    </p>
    <div class="part-content">
      <div class="content-title content-text-change">(1) 实验原理：
        <span class="tips">（限1000字以内）
        </span>
      </div>
      <div
        class="content-text content-text-change"
        v-if="!formInfo.theory_content"
      >暂无内容</div>
      <div
        class="content-text content-text-change"
        v-if="formInfo.theory_content"
        v-html="formInfo.theory_content"
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">知识点数量：</span>
      <div v-if="formInfo.theory_point"><b>{{ formInfo.theory_point.length }}</b> 个</div>
      <div v-else><b>0</b> 个</div>
      <div class="clearfix"></div>
      <span class="content-title"></span>
      <div
        class="content-text"
        v-if="formInfo.theory_point.length > 0"
      >
        <ol>
          <li
            v-for="(item, index) in formInfo.theory_point"
            :key="index"
          >
            ({{ index + 1 }}) {{ item.content }}
          </li>
        </ol>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
      <div class="clearfix"></div>
      <div class="content-title content-text-change">(2) 核心要素仿真设计：
        <span class="tips">（对系统或对象的仿真模型体现的客观结构、功能及其运动规律的实验场景进行如实描述，限500字以内）
        </span>
      </div>
      <div
        class="content-text content-text-change"
        v-if="!formInfo.theory_core"
      >暂无内容</div>
      <div
        class="content-text content-text-change"
        v-if="formInfo.theory_core"
        v-html="formInfo.theory_core"
      ></div>
    </div>
    <p class="part-title">实验教学过程与实验方法
    </p>
    <div
      class="part-content"
      v-if="!formInfo.tech_func"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.tech_func"
      v-html="formInfo.tech_func"
    ></div>
    <p class="part-title">步骤要求
    </p>
    <div class="tips">（不少于10步的学生交互性操作步骤。操作步骤应反映实质性实验交互，系统加载之类的步骤不计入在内）</div>
    <div class="part-content"><span class="content-title">（1）学生交互性操作步骤：</span>
      <div class="content-text">共{{formInfo.step_claim_step.length?formInfo.step_claim_step.length:'--'}}步</div>
      <div class="clearfix"></div>
      <div class="content-text-table">
        <table class="part-new-table">
          <tbody>
            <tr class="l_header">
              <th width="50">序号</th>
              <th width="120">
                <p>步骤名称</p>
                <p class="th-sub">（100字以内）</p>
              </th>
              <th width="200">
                <p>步骤目标要求</p>
                <p class="th-sub">（100字以内）</p>
              </th>
              <th width="110">
                <p>步骤合理用时</p>
                <p class="th-sub">（分钟）</p>
              </th>
              <th width="200">
                <p>目标达成度赋分模型</p>
                <p class="th-sub">（200字以内）</p>
              </th>
              <th width="80">步骤满分</th>
              <th width="130">成绩类型</th>
            </tr>

            <tr
              v-for="(item,index) in formInfo.step_claim_step"
              :key="index"
            >
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.target}}</td>
              <td>{{item.useTime}}</td>
              <td>{{item.model}}</td>
              <td>{{item.score}}</td>
              <td><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="1"
                  >预习成绩</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="2"
                  >操作成绩</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    checked=""
                    v-model="item.scoreType"
                    value="3"
                  >实验报告</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="4"
                  >教师评价报告</label></td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="clearfix"></div><span class="content-title">（2）交互性步骤详细说明：</span>
      <div class="clearfix"></div>
      <div
        class="content-text no-float"
        v-if="!formInfo.step_claim_step_des"
      >暂无内容</div>
      <div
        class="content-text no-float"
        v-if="formInfo.step_claim_step_des"
        v-html="formInfo.step_claim_step_des"
      >暂无内容</div>
    </div>
    <p class="part-title">实验结果与结论
    </p>
    <p class="tips">（说明在不同实验条件和操作下可能产生的实验结果与结论）</p>
    <div class="part-content">
      <div
        class="content-text"
        v-if="!formInfo.experiment_result"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.experiment_result"
        v-html="formInfo.experiment_result"
      >暂无内容</div>
    </div>
    <p class="part-title">面向学生要求
    </p>
    <div class="part-content">
      <span class="content-title">专业与年级要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.student_claim_subject"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.student_claim_subject"
        v-html="formInfo.student_claim_subject"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">基本知识和能力要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.student_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.student_claim_content"
        v-html="formInfo.student_claim_content"
      ></div>
    </div>
    <p class="part-title">实验应用及共享情况
    </p>
    <div class="part-content">
      <span class="content-title">本校上线时间：</span>
      <div class="content-text">{{this.formInfo.share_situation.onlineTime?this.formInfo.share_situation.onlineTime:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">系统日志：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(1)"
      >{{this.formInfo.share_situation.systemLogName?this.formInfo.share_situation.systemLogName:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">已服务过的本校学生人数：</span>
      <div class="content-text">{{this.formInfo.share_situation.studentNum?this.formInfo.share_situation.studentNum:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">已服务过的外校学生人数：</span>
      <div class="content-text">{{this.formInfo.share_situation.studentNum2?this.formInfo.share_situation.studentNum2:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <div class="clearfix"></div>
      <span class="content-title">所属课程教学计划或授课提纲：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(2)"
      >{{this.formInfo.share_situation.courseTextName?this.formInfo.share_situation.courseTextName:'暂无内容'}}</div>
      <div class="clearfix"></div><span class="content-title">纳入教学计划的专业数：</span>
      <div class="content-text">{{formInfo.share_situation.subjectList?formInfo.share_situation.subjectList.length:'--'}}</div>
      <div class="clearfix"></div><span class="content-title">具体专业：</span>
      <div
        class="content-text"
        style="margin-right:10px"
        v-for="(item,index) in formInfo.share_situation.subjectList"
        :key="index"
      >{{item.subjectTitle}}</div>
      <div class="clearfix"></div><span class="content-title">是否面向社会提供服务：</span>
      <div class="content-text">{{this.formInfo.share_situation.societyNum?this.formInfo.share_situation.societyNum:'暂无内容'}}</div>
      <div class="clearfix"></div>
    </div>

    <div
      id="res-preview-overlay"
      :style="formatShowWindow(showWindow.preview)"
    >
      <div id="res-preview-overlay-bg"></div>
      <div id="res-preview-panel">
        <div id="res-preview-title">{{previewInfo.title_name}}
          <div
            id="res-preview-close"
            @click="showWindow.preview = false"
          >x</div>
        </div>
        <div id="res-preview-content">
          <div v-if="previewInfo.previewType==1">
            <excel-view :datas="previewInfo.excelData"></excel-view>
          </div>
          <div
            class="pdf-region"
            v-else
          >
            <pdf
              :page="pageNum"
              :src="previewInfo.previewPath"
              @progress="loadedRatio = $event"
              @num-pages="pageTotalNum=$event"
            ></pdf>
            <div class="pagecolor">
              <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ExcelView from '../../components/ExcelView'
import pdf from 'vue-pdf'
export default {
  name: 'ExperimentDes',
  components: {
    pdf,
    ExcelView
  },
  props: ['expId'],
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      theoryPointList: [],
      showWindow: {
        preview: false
      },
      formInfo: {
        tech_goal: '',
        theory_content: '',
        theory_point: '',
        theory_core: '',
        time_lesson: '',
        time_experiment: '',
        introduce: '',
        tech_func: '',
        experiment_result: '',
        student_claim_subject: '',
        student_claim_content: '',
        step_claim_step: [],
        step_claim_step_des: '',
        share_situation: {}
      },
      // 实验简介表单数据
      formIntroduce: {
        introduce: ''
      },
      // 实验教学目标表单数据
      formTechGoal: {
        tech_goal: ''
      },
      // 实验课时表单数据
      formClassHour: {
        time_lesson: '',
        time_experiment: ''
      },
      // 实验原理表单数据
      formTheory: {
        theory_content: '',
        theory_point: '',
        theory_core: ''
      },
      // 实验教学过程与实验方法表单数据
      formTechFunc: {
        tech_func: ''
      },
      // 步骤要求表单数据
      formStep: {
        step_claim_step: [],
        step_claim_step_des: ''
      },
      // 实验结果与结论表单数据
      formExperimentResult: {
        experiment_result: ''
      },
      // 面向学生要求表单数据
      formStudent: {
        student_claim_subject: '',
        student_claim_content: ''
      },
      // 实验应用及共享情况表单数据
      formProj: {
        onlineTime: '',
        systemLogPath: '',
        systemLogName: '',
        studentNum: '',
        studentNum2: '',
        courseTextName: '',
        courseTextPath: '',
        subjectList: [],
        isToSociety: '2',
        openTime: '',
        societyNum: ''
      },
      stepInfo: [],
      toggleUpload: 1,

      previewInfo: {
        previewType: '',
        title_name: '',
        previewPath: '',
        excelData: null
      }
    }
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    getPreviewInfo(val) {
      this.previewInfo.previewType = val

      if (val === 2) {
        if (this.formInfo.share_situation.courseTextName) {
          this.previewInfo.title_name = this.formInfo.share_situation.courseTextName
          this.previewInfo.previewPath = this.formInfo.share_situation.courseTextPath
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      } else if (val === 1) {
        if (this.formInfo.share_situation.systemLogName) {
          this.previewInfo.title_name = this.formInfo.share_situation.systemLogName
          this.previewInfo.previewPath = this.formInfo.share_situation.systemLogPath
          this.showWindow.preview = true
          const layerload = this.$layer.loading({
            time: 5
          })
          this.$http.get(this.$store.state.api + this.previewInfo.previewPath, {
            responseType: 'arraybuffer',
            baseURL: ''
          }).then((res) => {
            this.$layer.close(layerload)
            this.previewInfo.excelData = res
          })
        } else {
          this.showWindow.preview = false
        }
      }
    },
    formatNum(num, val) {
      var value = val ? val.length : 0
      return Number(num - value)
    },
    /**
     * 根据字段打开/关闭相应的弹窗
     */
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {
          visibility: 'hidden'
        }
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.step_claim_step = data.step_claim_step ? JSON.parse(data.step_claim_step) : []
        this.formInfo.share_situation = data.share_situation ? JSON.parse(data.share_situation) : ''
        this.formInfo.theory_point = data.theory_point ? JSON.parse(data.theory_point) : ''
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-infor-2020.css"></style>

<style lang="less" scoped>
</style>
